/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import './style.scss';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const event = new CustomEvent('swUpdated', { detail: { registration } });
    window.dispatchEvent(event);
  },
  // autoUpdate removed: NewVersionCheck handles the update banner + reload manually.
  // autoUpdate: true was fighting with the banner flow — it would auto-reload via
  // controllerchange before the user clicked Refresh, leaving the banner with a null
  // reg.waiting and causing a broken fallback reload path.
});

if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

// When the page becomes visible or gains focus, detect if any registration has a waiting worker
function notifyIfWaiting() {
  if (!('serviceWorker' in navigator) || !navigator.serviceWorker.getRegistrations) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((r) => {
      if (r.waiting) {
        const event = new CustomEvent('swUpdated', { detail: { registration: r } });
        window.dispatchEvent(event);
      }
    });
  }).catch((e) => { console.warn('[sw-reg] getRegistrations failed', e); });
}

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') notifyIfWaiting();
});
window.addEventListener('focus', () => notifyIfWaiting());

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
